exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chatbot-dialog {\n  position: absolute;\n  bottom: 90px;\n  right: 30px;\n  z-index: 999;\n  border-radius: 4px;\n  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08);\n  background: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n.chatbot-dialog.hidden {\n  display: none;\n}\n.chatbot-dialog .ant-divider {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n", ""]);

// exports
